<template>
  <el-row>
    <el-form label-position="right" ref="form" :model="form.model" :rules="form.rules" label-width="120px">
      <el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>基本信息</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="用户" prop="customerName">
              <el-input v-model="form.model.valueObject.contract.customer.name" :disabled="true" v-if="form.model.valueObject != null" size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="合同名称" prop="contractName">
              <el-input v-model="form.model.valueObject.contract.name" :disabled="true" v-if="form.model.valueObject != null" size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="合同编号" prop="contractSid">
              <el-input v-model="form.model.valueObject.contract.sid" :disabled="true" v-if="form.model.valueObject != null" size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="操作时间" prop="lastUpdateTime">
              <el-input v-model="form.model.lastUpdateTime" :disabled="true" size="mini">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="操作人" prop="lastUpdateUserId">
              <el-input v-model="form.model.lastUpdateUserRealName" :disabled="true" size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <div class="bottom20">
        <el-row class="column-name" justify="start">
          <span>操作详情</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <contract-record-difference :difference="difference">

            </contract-record-difference>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </el-row>
</template>

<script>
import DataRecordApi from "@/api/billing/data-record-api";
import {handleError} from "@/util/error-util";
import {differentiate} from "@/views/billing/contract/record/contract-record-common";
import ContractRecordDifference from "@/views/billing/contract/record/contract-record-difference";
import {PersonServer} from "@/api";

async function getFormModelById(id) {
  let model;
  let response;
  try {
    response = await DataRecordApi.get(id, {
      params: {
        isQueryPrevious: true,
      }
    });
    if (response != null && response.data.success) {
      let record = response.data.data;
      if (record != null) {
        record.valueObject = JSON.parse(record.value);
        if (record.previous != null) {
          record.previous.valueObject = JSON.parse(record.previous.value);
        }

        record.lastUpdateUserRealName = record.lastUpdateUserId;
        if (record.lastUpdateUserId != null) {
          let res = await PersonServer.personApi.get(record.lastUpdateUserId);
          if (String(res.data.code) === '200') {
            let person = res.data.data;
            if (person != null) {
              record.lastUpdateUserRealName = person.realname;
            }
          }
        }
      }
      model = record;
    }
  } catch (e) {
    handleError(e);
  }
  return model;
}

export default {
  name: "contract-record-detail",
  components: {ContractRecordDifference},
  data() {
    return {
      form: {
        model: {
          id: null,
          createUserId: null,
          createTime: null,
          lastUpdateUserId: null,
          lastUpdateTime: null,
          version: null,

          defineId: null,
          previousId: null,
          nextId: null,
          value: null,
          status: null,

          valueObject: null,
        }
      },
      difference: {
        type: null,
        contract: [],
        contractItems: {
          adds: [],
          updates: [],
          deletes: [],
        },
      },
    };
  },
  methods: {
    async look(id) {
      let model = await getFormModelById(id);
      if (model != null) {
        await this.differentiate(model, model.previous);
        this.form.model = model;
      }
      return this.form.model;
    },
    async differentiate(current, previous) {
      this.difference = await differentiate(current, previous);
    },
  },
}
</script>

<style scoped>

</style>